import { object, string } from 'yup'

import { i18nErrorCodes } from '../form-utils'

const { required } = i18nErrorCodes

export default object().shape({
  goals:        string().required(required),
  achievements: string().required(required),
})

export const emptySessionMeta = {
  goals:        '',
  achievements: '',
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/session-meta.schema.ts